module.exports = "<cian-af-about-object-has-furniture ad=\"hasFurniture.ad\" form=\"hasFurniture.form\"></cian-af-about-object-has-furniture>"